/** @jsxImportSource @emotion/react */
import { useState, useEffect, useMemo, useRef } from "react";
import { useParams } from "react-router-dom";
import { Toast } from "primereact/toast";
import { Skeleton } from "primereact/skeleton";
import { Card } from "primereact/card";
import { Sidebar } from "../../../../shared";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Tag } from "primereact/tag";
import { Menu } from "primereact/menu";
import { Tooltip } from "primereact/tooltip";
import {
  Boton,
  Titulo,
  Formulario,
  CampoInformacion,
  accessAPI,
  TablaFiltrable
} from "../../../../shared";
export default function PlanActividades() {
  const [loader, setLoader] = useState(true);
  const [plan, setPlan] = useState();
  const [certificados, setCertificados] = useState([]);
  const [actividades, setActividades] = useState([]);
  const [agregarActividadLoader, setAgregarActividadLoader] = useState(false);
  const [loaderActivo, setLoaderActivo] = useState(false);
  const [sideBarEditar, setSideBarEditar] = useState(false);
  const [loaderEditar, setLoaderEditar] = useState(false);
  const [formEditarKey, setFormEditarKey] = useState(0);
  const [sideBarCertTipo, setSideBarCertTipo] = useState(false);
  const [loaderCertTipo, setLoaderCertTipo] = useState(false);
  const [formKeyCertTipo, setFormKeyCertTipo] = useState(0);
  const [sideBarActividad, setSideBarActividad] = useState(false);
  const [formKeyActividad, setFormKeyActividad] = useState(0);
  const [sideBarEditarActividad, setSideBarEditarActividad] = useState(false);
  const [loaderEditarActividad, setLoaderEditarActividad] = useState(false);
  const [formKeyEditarActividad, setFormKeyEditarActividad] = useState(0);
  const [actividadSeleccionada, setActividadSeleccionada] = useState(null);

  const toast = useRef(null);
  const menuActividad = useRef(null);
  const { planId } = useParams();

  useEffect(() => {
    cargarPlan();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function cargarPlan() {
    accessAPI(
      "GET",
      `admin/planificacion/planesactividades/${planId}`,
      null,
      (respuesta) => {
        setPlan(respuesta.plan);

        const certificadosDelPlan =
          respuesta.plan.plandeactividades_x_certificadotipo?.map(
            (pc) => pc.certificadotipo
          ) || [];

        const actividadesDelPlan = respuesta.plan.actividadenplan || [];

        setCertificados([...certificadosDelPlan]);
        setActividades([...actividadesDelPlan]);

        setLoader(false);
        document.title = `Plan: ${respuesta.plan.nombre}`;
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cargar plan",
          sticky: true
        });
        setLoader(false);
      }
    );
  }

  function toggleActivo() {
    setLoaderActivo(true);
    const nuevoEstado = !plan.activo;
    accessAPI(
      "PUT",
      `admin/planificacion/planesactividades/${planId}`,
      { activo: nuevoEstado },
      () => {
        setPlan((prev) => ({ ...prev, activo: nuevoEstado }));
        setLoaderActivo(false);
      },
      (respuesta) => {
        setLoaderActivo(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al actualizar",
          sticky: true
        });
      }
    );
  }

  function guardarEdicion(datosFormulario) {
    setLoaderEditar(true);
    accessAPI(
      "PUT",
      `admin/planificacion/planesactividades/${planId}`,
      datosFormulario,
      (respuesta) => {
        setPlan((prev) => ({ ...prev, ...respuesta.plan }));
        document.title = `Plan: ${respuesta.plan.nombre}`;
        setLoaderEditar(false);
        setSideBarEditar(false);
      },
      (respuesta) => {
        setLoaderEditar(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al actualizar",
          sticky: true
        });
      }
    );
  }

  function getEditarFormConfig() {
    return {
      secciones: [
        {
          campos: [
            {
              nombre: "nombre",
              tipoitemformularioid: 1,
              etiqueta: "Nombre del plan",
              requerido: true,
              respuesta: plan?.nombre
            },
            {
              nombre: "comentario",
              tipoitemformularioid: 11,
              etiqueta: "Comentario",
              respuesta: plan?.comentario
            }
          ]
        }
      ],
      botones: [
        {
          etiqueta: "Guardar",
          callback: guardarEdicion,
          validar: true
        }
      ]
    };
  }

  function agregarCertificadoTipo(datosFormulario) {
    setLoaderCertTipo(true);
    accessAPI(
      "POST",
      `admin/planificacion/planesactividades/${planId}/certificado`,
      datosFormulario,
      () => {
        setLoaderCertTipo(false);
        setSideBarCertTipo(false);
        cargarPlan();
      },
      (respuesta) => {
        setLoaderCertTipo(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al agregar certificado",
          sticky: true
        });
      }
    );
  }

  function eliminarCertificadoTipo(cert) {
    confirmDialog({
      message: `¿Eliminar "${cert.procesotipo?.nombre} - ${cert.nombre}"?`,
      header: "Confirmar eliminación",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Eliminar",
      rejectLabel: "Cancelar",
      acceptClassName: "p-button-danger",
      accept: () => {
        accessAPI(
          "DELETE",
          `admin/planificacion/planesactividades/${planId}/certificado/${cert.id}`,
          null,
          () => {
            setCertificados((prev) => prev.filter((c) => c.id !== cert.id));
          },
          (respuesta) => {
            toast.current?.show({
              severity: "error",
              summary: "Error",
              detail: respuesta[0]?.msg || "Error al eliminar certificado",
              sticky: true
            });
          }
        );
      }
    });
  }

  const certTipoFormConfig = {
    secciones: [
      {
        campos: [
          {
            nombre: "certificadotipoid",
            tipoitemformularioid: 5,
            etiqueta: "Tipo de certificado",
            opciones: "admin/config/certificadotipo?dropdown=true",
            sinOpcionInicial: true,
            requerido: true
          }
        ]
      }
    ],
    botones: [
      {
        etiqueta: "Agregar",
        callback: agregarCertificadoTipo,
        validar: true
      }
    ]
  };

  function agregarActividad(contenidoCampos) {
    setAgregarActividadLoader(true);
    accessAPI(
      "POST",
      `admin/planificacion/planesactividades/${planId}/actividadenplan`,
      contenidoCampos,
      () => {
        setAgregarActividadLoader(false);
        setSideBarActividad(false);
        cargarPlan();
      },
      (respuesta) => {
        setAgregarActividadLoader(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al agregar actividad",
          sticky: true
        });
      }
    );
  }

  function getAgregarActividadFormConfig() {
    return {
      secciones: [
        {
          campos: [
            {
              nombre: "actividadtipoid",
              tipoitemformularioid: 5,
              etiqueta: "Tipo de Actividad",
              opciones: `admin/actividad/actividadTipo?dropdown=true&certificadotipoids=${certificados
                .map((c) => c.id)
                .join(",")}`,
              sinOpcionInicial: true,
              requerido: true
            },
            {
              nombre: "dentrodedias",
              tipoitemformularioid: 4,
              etiqueta: "Días después",
              requerido: true
            },
            {
              nombre: "comentario",
              tipoitemformularioid: 11,
              etiqueta: "Comentario (opcional)"
            }
          ]
        }
      ],
      botones: [
        {
          etiqueta: "Agregar actividad",
          callback: agregarActividad,
          validar: true
        }
      ]
    };
  }

  function editarActividad(datosFormulario) {
    setLoaderEditarActividad(true);
    accessAPI(
      "PUT",
      `admin/planificacion/actividadenplan/${actividadSeleccionada.id}`,
      datosFormulario,
      () => {
        setLoaderEditarActividad(false);
        setSideBarEditarActividad(false);
        cargarPlan();
      },
      (respuesta) => {
        setLoaderEditarActividad(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al editar actividad",
          sticky: true
        });
      }
    );
  }

  function eliminarActividad(actividad) {
    confirmDialog({
      message: `¿Eliminar "${actividad.actividadtipo?.nombre}"?`,
      header: "Confirmar eliminación",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Eliminar",
      rejectLabel: "Cancelar",
      acceptClassName: "p-button-danger",
      accept: () => {
        accessAPI(
          "DELETE",
          `admin/planificacion/actividadenplan/${actividad.id}`,
          null,
          () => {
            setActividades((prev) => prev.filter((a) => a.id !== actividad.id));
          },
          (respuesta) => {
            toast.current?.show({
              severity: "error",
              summary: "Error",
              detail: respuesta[0]?.msg || "Error al eliminar actividad",
              sticky: true
            });
          }
        );
      }
    });
  }

  function getEditarActividadFormConfig() {
    return {
      secciones: [
        {
          campos: [
            {
              nombre: "dentrodedias",
              tipoitemformularioid: 4,
              etiqueta: "Días después",
              requerido: true,
              respuesta: actividadSeleccionada?.dentrodedias
            },
            {
              nombre: "comentario",
              tipoitemformularioid: 11,
              etiqueta: "Comentario",
              respuesta: actividadSeleccionada?.comentario
            }
          ]
        }
      ],
      botones: [
        {
          etiqueta: "Guardar",
          callback: editarActividad,
          validar: true
        }
      ]
    };
  }

  // Calcular incompatibilidades detalladas
  const incompatibilidadesDetalle = useMemo(() => {
    const detalles = [];

    actividades.forEach((actividad) => {
      const certificadosIncompatibles = [];

      certificados.forEach((cert) => {
        const esCompatible =
          actividad.actividadtipo?.actividadtipo_x_certificadotipo?.some(
            (ac) => ac.certificadotipoid === cert.id
          );

        if (!esCompatible) {
          certificadosIncompatibles.push(cert.nombre);
        }
      });

      if (certificadosIncompatibles.length > 0) {
        detalles.push({
          actividadNombre:
            actividad.actividadtipo?.nombre || "Actividad sin nombre",
          certificadosIncompatibles: certificadosIncompatibles
        });
      }
    });

    return detalles;
  }, [actividades, certificados]);

  const hayIncompatibilidades = incompatibilidadesDetalle.length > 0;

  return (
    <>
      <Toast ref={toast} position="top-center" />
      <ConfirmDialog />

      {loader && (
        <div css={{ marginTop: "2em", display: "flex", flexDirection: "column", gap: "1em" }}>
          <div css={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div css={{ display: "flex", alignItems: "center", gap: "1em" }}>
              <Skeleton width="2rem" height="2rem" shape="circle" />
              <Skeleton width="16rem" height="2rem" />
            </div>
            <Skeleton width="8rem" height="2.5rem" />
          </div>
          <Card>
            <Skeleton width="6rem" height="1.5rem" css={{ marginBottom: "1em" }} />
            <Skeleton width="60%" height="1.2rem" />
          </Card>
          <div className="grid">
            <div className="col-12 lg:col-6">
              <Card>
                <Skeleton width="10rem" height="1.5rem" css={{ marginBottom: "1em" }} />
                <Skeleton width="100%" height="3rem" css={{ marginBottom: "0.3rem" }} />
                <Skeleton width="100%" height="3rem" css={{ marginBottom: "0.3rem" }} />
                <Skeleton width="100%" height="3rem" />
              </Card>
            </div>
            <div className="col-12 lg:col-6">
              <Card>
                <Skeleton width="10rem" height="1.5rem" css={{ marginBottom: "1em" }} />
                <Skeleton width="100%" height="3rem" css={{ marginBottom: "0.3rem" }} />
                <Skeleton width="100%" height="3rem" css={{ marginBottom: "0.3rem" }} />
                <Skeleton width="100%" height="3rem" />
              </Card>
            </div>
          </div>
        </div>
      )}

      {!loader && plan && (
        <div>
          <Titulo
            urlVolver="/config/planes-actividades"
            etiqueta={!plan.activo ? "Desactivado" : null}
            error={!plan.activo}
            botones={
              <Boton
                rojo
                transparente
                callback={toggleActivo}
                loader={loaderActivo}
              >
                {plan.activo ? "Desactivar" : "Activar"}
              </Boton>
            }
          >
            {plan.nombre}
          </Titulo>

          <Sidebar
            visible={sideBarEditar}
            onHide={() => setSideBarEditar(false)}
            position="right"
            className="w-full lg:w-30rem md:w-30rem"
          >
            <Titulo>Editar plan</Titulo>
            <Formulario
              config={getEditarFormConfig()}
              loader={loaderEditar}
              key={formEditarKey}
            />
          </Sidebar>

          <Card>
            <Titulo
              botones={
                <Boton
                  texto
                  negro
                  callback={() => {
                    setFormEditarKey((prev) => prev + 1);
                    setSideBarEditar(true);
                  }}
                >
                  <i className="pi pi-pencil" />
                </Boton>
              }
            >
              Detalles
            </Titulo>
            <div className="grid">
              <CampoInformacion nombreCampo="Nombre">
                {plan.nombre}
              </CampoInformacion>
            </div>
            {plan.comentario && (
              <>
                <hr
                  css={{
                    border: "none",
                    borderTop: "1px solid #dee2e6",
                    margin: "0.5em 0"
                  }}
                />
                <div css={{ color: "var(--grisTextos)", marginBottom: "4px" }}>
                  Comentario:
                </div>
                <div>{plan.comentario}</div>
              </>
            )}
          </Card>

          <Sidebar
            visible={sideBarCertTipo}
            onHide={() => setSideBarCertTipo(false)}
            position="right"
            className="w-full lg:w-30rem md:w-30rem"
          >
            <Titulo>Agregar tipo de certificado</Titulo>
            <Formulario
              config={certTipoFormConfig}
              loader={loaderCertTipo}
              key={formKeyCertTipo}
            />
          </Sidebar>

          <Sidebar
            visible={sideBarActividad}
            onHide={() => setSideBarActividad(false)}
            position="right"
            className="w-full lg:w-30rem md:w-30rem"
          >
            <Titulo>Agregar actividad</Titulo>
            <Formulario
              config={getAgregarActividadFormConfig()}
              loader={agregarActividadLoader}
              key={formKeyActividad}
            />
          </Sidebar>

          <Sidebar
            visible={sideBarEditarActividad}
            onHide={() => setSideBarEditarActividad(false)}
            position="right"
            className="w-full lg:w-30rem md:w-30rem"
          >
            <Titulo>{actividadSeleccionada?.actividadtipo?.nombre}</Titulo>
            <Formulario
              config={getEditarActividadFormConfig()}
              loader={loaderEditarActividad}
              key={formKeyEditarActividad}
            />
          </Sidebar>

          <Menu
            ref={menuActividad}
            popup
            model={[
              {
                label: "Editar",
                icon: "pi pi-pencil",
                command: () => {
                  setFormKeyEditarActividad((prev) => prev + 1);
                  setSideBarEditarActividad(true);
                }
              },
              {
                label: "Eliminar",
                icon: "pi pi-trash",
                className: "menuItemRojo",
                command: () => {
                  if (actividadSeleccionada)
                    eliminarActividad(actividadSeleccionada);
                }
              }
            ]}
          />

          <div className="grid" css={{ marginTop: "1em" }}>
            <div className="col-12 lg:col-6">
              <Card>
                <Titulo
                  botones={
                    <Boton
                      texto
                      negro
                      callback={() => {
                        setFormKeyCertTipo((prev) => prev + 1);
                        setSideBarCertTipo(true);
                      }}
                    >
                      <i className="pi pi-plus" />
                    </Boton>
                  }
                >
                  Tipos de Certificado
                </Titulo>
                <TablaFiltrable conFiltros={false}
                  value={certificados}
                  nombreArchivo="tipos_certificado_plan"
                  size="small"
                  emptyMessage="No hay tipos de certificado asignados"
                >
                  <Column
                    header="Tipo de Proceso"
                    body={(rowData) => rowData.procesotipo?.nombre || "—"}
                  />
                  <Column field="nombre" header="Nombre" />
                  <Column
                    body={(rowData) => (
                      <Boton
                        texto
                        rojo
                        chico
                        callback={() => eliminarCertificadoTipo(rowData)}
                      >
                        <i className="pi pi-trash" />
                      </Boton>
                    )}
                    style={{ width: "4rem", textAlign: "center" }}
                  />
                </TablaFiltrable>
              </Card>
            </div>

            <div className="col-12 lg:col-6">
              <Card>
                <Titulo
                  botones={
                    certificados.length > 0 ? (
                      <Boton
                        texto
                        negro
                        callback={() => {
                          setFormKeyActividad((prev) => prev + 1);
                          setSideBarActividad(true);
                        }}
                      >
                        <i className="pi pi-plus" />
                      </Boton>
                    ) : null
                  }
                >
                  Actividades del Plan
                </Titulo>

                {hayIncompatibilidades && (
                  <div
                    css={{
                      background: "#fff3cd",
                      border: "1px solid #ffc107",
                      borderRadius: "6px",
                      padding: "0.75em 1em",
                      marginBottom: "1em",
                      fontSize: "0.9em"
                    }}
                  >
                    <div css={{ fontWeight: "bold", marginBottom: "0.5em" }}>
                      <i
                        className="pi pi-exclamation-triangle"
                        css={{ marginRight: "0.5em" }}
                      />
                      Hay actividades incompatibles
                    </div>
                    <ul css={{ margin: 0, paddingLeft: "1.2em" }}>
                      {incompatibilidadesDetalle.map((detalle, idx) => (
                        <li key={idx}>
                          <strong>{detalle.actividadNombre}</strong> no es
                          compatible con:{" "}
                          {detalle.certificadosIncompatibles.join(", ")}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                <TablaFiltrable conFiltros={false}
                  value={actividades}
                  nombreArchivo="actividades_plan"
                  size="small"
                  emptyMessage={
                    certificados.length === 0
                      ? "Primero debes agregar al menos un tipo de certificado"
                      : "No hay actividades configuradas"
                  }
                >
                  <Column field="actividadtipo.nombre" header="Actividad" />
                  <Column
                    header="Días después"
                    body={(rowData) => {
                      const dias = rowData.dentrodedias;
                      let severity = "info";
                      if (dias === 0) severity = "danger";
                      else if (dias <= 7) severity = "warning";
                      return <Tag value={`${dias}`} severity={severity} />;
                    }}
                    style={{ width: "8rem", textAlign: "center" }}
                  />
                  <Column
                    body={(rowData) => {
                      if (!rowData.comentario) return null;
                      const tooltipId = `actividad-comentario-${rowData.id}`;
                      return (
                        <>
                          <Tooltip
                            target={`#${tooltipId}`}
                            content={rowData.comentario}
                            position="top"
                          />
                          <i
                            id={tooltipId}
                            className="pi pi-info-circle"
                            style={{
                              color: "var(--amarillo)",
                              fontSize: "1.1rem",
                              cursor: "pointer"
                            }}
                          />
                        </>
                      );
                    }}
                    style={{ width: "3rem", textAlign: "center" }}
                  />
                  <Column
                    body={(rowData) => (
                      <Boton
                        texto
                        negro
                        chico
                        callback={(e) => {
                          setActividadSeleccionada(rowData);
                          menuActividad.current.toggle(e);
                        }}
                      >
                        <i className="pi pi-ellipsis-v" />
                      </Boton>
                    )}
                    style={{ width: "3rem", textAlign: "center" }}
                  />
                </TablaFiltrable>
              </Card>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
